import { useEffect, useState } from "react";
import { toast } from "sonner";
import { QrCode, Save, Globe } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { batchUrl } from "@/lib/qr";
import { PageHeader } from "@/components/StatCard";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function Settings() {
  const [url, setUrl] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings/public").then((r) => setUrl(r.data.qr_base_url || "")); }, []);
  const save = async () => {
    setSaving(true);
    try { const r = await api.put("/settings/qr", { qr_base_url: url }); setUrl(r.data.qr_base_url); toast.success("Alamat website untuk QR disimpan"); }
    catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };
  return (
    <div data-testid="settings-page" className="max-w-2xl">
      <PageHeader title="Pengaturan" subtitle="Konfigurasi sistem untuk label QR dan tautan batch." />
      <div className="card-aqua p-5" data-testid="qr-settings">
        <div className="flex items-center gap-2 mb-1"><QrCode className="h-5 w-5 text-sky-600" /><h3 className="font-bold text-slate-800">Alamat website untuk QR</h3></div>
        <p className="text-sm text-slate-500 mb-4">QR pada label batch berisi tautan ke halaman detail batch. Isi dengan alamat tetap aplikasi ini (mis. <code className="font-mono text-sky-700">https://gudang.cahayafishbali.com</code>) agar label tetap berfungsi walau dibuka dari HP mana pun.</p>
        <div className="relative">
          <Globe className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-sky-500" />
          <Input value={url} onChange={(e) => setUrl(e.target.value)} placeholder={window.location.origin} className="pl-10 h-11" data-testid="input-qr-base-url" />
        </div>
        {!url && <div className="mt-2 text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2" data-testid="qr-url-warning">Belum diatur — label sementara memakai alamat yang sedang dibuka: <code className="font-mono">{window.location.origin}</code></div>}
        <div className="mt-3 text-xs text-slate-500">Contoh isi QR: <code className="font-mono text-slate-700" data-testid="qr-url-example">{batchUrl(url, "CFB-240601-001")}</code></div>
        <div className="mt-4 flex flex-wrap gap-2">
          <Button onClick={save} disabled={saving} className="rounded-full bg-sky-600 hover:bg-sky-700" data-testid="btn-save-qr-settings"><Save className="h-4 w-4 mr-1" /> {saving ? "Menyimpan..." : "Simpan"}</Button>
          {url && <Button type="button" variant="outline" className="rounded-full" onClick={() => window.open(`${url.replace(/\/+$/, "")}/login`, "_blank")} data-testid="btn-test-qr-url"><Globe className="h-4 w-4 mr-1" /> Tes buka alamat</Button>}
        </div>
        <p className="mt-3 text-[11px] text-slate-500" data-testid="qr-url-ssl-hint">Pastikan alamat ini sudah terhubung ke aplikasi dan sertifikat HTTPS-nya aktif. Bila muncul error seperti <code className="font-mono">ERR_SSL_VERSION_OR_CIPHER_MISMATCH</code>, domain belum ditautkan di panel Deployment → Domains.</p>
      </div>
    </div>
  );
}
